// Global Users Listing
export const SALESX_USERS_LISTING = {
  LOAD: "SALESX_USERS_LISTING_LOAD",
  LOAD_SUCCESS: "SALESX_USERS_LISTING_LOAD_SUCCESS",
  FAIL: "SALESX_USERS_LISTING_LOAD_FAIL",
  RESET: "SALESX_USERS_LISTING_RESET",
  SET_SEARCH_TERM: "SALESX_USERS_LISTING_SET_SEARCH_TERM",
  EXPORT_REMOVE: "SALESX_USERS_LISTING_EXPORT_REMOVE",
};

// Groups Listing
export const SALESX_GROUPS_LISTING = {
  LOAD: "SALESX_GROUPS_LISTING_LOAD",
  LOAD_SUCCESS: "SALESX_GROUPS_LISTING_LOAD_SUCCESS",
  FAIL: "SALESX_GROUPS_LISTING_LOAD_FAIL",
  RESET: "SALESX_GROUPS_LISTING_RESET",
  UPDATE_GROUP_USERS_COUNT: "SALESX_GROUPS_LISTING_UPDATE_GROUP_USERS_COUNT",
  EXPORT_REMOVE: "SALESX_GROUPS_LISTING_EXPORT_REMOVE",
};

// Indivisual Group's Users Listing
export const SALESX_GROUP_DETAIL = {
  UPDATE: "SALESX_GROUP_DETAIL_UPDATE",
  LOAD: "SALESX_GROUP_DETAIL_LOAD",
  SUCCESS: "SALESX_GROUP_DETAIL_SUCCESS",
  FAIL: "SALESX_GROUP_DETAIL_FAIL",
  RESET: "SALESX_GROUP_DETAIL_RESET",
  DELETE_LOAD: "SALESX_GROUP_DETAIL_DELETE_LOAD",
  DELETE_SUCCESS: "SALESX_GROUP_DETAIL_DELETE_SUCCESS",
  DELETE_FAIL: "SALESX_GROUP_DETAIL_DELETE_FAIL",
  ADD_LOAD: "SALESX_GROUP_DETAIL_ADD_LOAD",
  ADD_SUCCESS: "SALESX_GROUP_DETAIL_ADD_SUCCESS",
  ADD_FAIL: "SALESX_GROUP_DETAIL_ADD_FAIL",
  APPLY_FILTERS: "SALESX_GROUP_DETAILS_APPLY_FILTERS",
  GLOBAL_LISTING: "SALESX_GROUP_DETAILS_GLOBAL_LISTING",
  RESET_USERS: "SALESX_GROUP_DETAIL_RESET_USERS",
  ADD_USERS: "SALESX_GROUP_DETAIL_ADD_USERS",
  MESSAGE: "SALESX_GROUP_DETAIL_MESSAGE",
};

// Create Group
export const CREATE_SALESX_GROUP = {
  LOAD: "CREATE_SALESX_GROUP_LOAD",
  SUCCESS: "CREATE_SALESX_GROUP_SUCCESS",
  FAIL: "CREATE_SALESX_GROUP_FAIL",
};

// Group Name Update
export const SALESX_GROUP_NAME_UPDATE = {
  LOAD: "SALESX_GROUP_NAME_UPDATE_LOAD",
  SUCCESS: "SALESX_GROUP_NAME_SUCCESS",
  FAIL: "SALESX_GROUP_NAME_FAIL",
};

// Delete Group
export const SALESX_GROUP_DELETE = {
  LOAD: "SALESX_GROUP_DELETE_LOAD",
  SUCCESS: "SALESX_GROUP_DELETE_SUCCESS",
  FAIL: "SALESX_GROUP_DELETE_FAIL",
};
